import styled, { css } from "styled-components";
import { DayPicker } from "react-day-picker";
import { alpha } from "@commonlibs";

export const DatePickerCalendarRoot = styled(DayPicker)(
    ({ theme: { palette } }) => css`
        .my-today {
            font-weight: bold;
            color: ${palette.gold};
        }
        .my-selected {
            background-color: ${alpha(palette.primary, 0.3)};
        }
        .my-selected:hover {
            background-color: ${alpha(palette.primary, 0.3)};
        }
        .date-picker-footer {
            margin-top: 0.5rem;
        }
        color: ${palette.primary};
    `,
) as typeof DayPicker;
